import { LegalPageLayout } from "@/src/legal/components/legal-page-layout";

export function PrivacyPage() {
	return <LegalPageLayout documentKey="privacy" />;
}
